import { ButterCmsComponentSchema } from "../types/ButterCmsComponentSchema"
import { ButterCmsPageSchema } from "../types/ButterCmsPageSchema"

export const getFields = <FieldType>(
  element: ButterCmsPageSchema<FieldType> | ButterCmsComponentSchema<FieldType>
): FieldType => element.fields
